import { Helmet } from "react-helmet";
import {
  Box,
  Collapse,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronUp } from "../../../../assets/icons/chevron-expand-up.svg";
import * as Util from "../../../../services/global.service";
const useStyles = makeStyles({
});


const Summary360 = (props) => {
  const { data, name, start, last } = props
  const classes = useStyles();
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(true);
  let onChangeOpen = () => {
    setOpen(!open)
  }
  return (
    <Box >
      <Box sx={{ display: "flex", alignItems: "center", height: "50px", borderBottom: "1px solid #E5E5E5" }}>
        <Box ml="20px" mr="12px" sx={{ background: "#F5F5F5", borderRadius: "2px", height: "25px", width: "25px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={onChangeOpen}>
          {open ? <ChevronUp /> : <ChevronDown />}
        </Box>
        <Typography width="calc(57.03% - 57px)" pr="20px" color="#5DA196" fontWeight="600" fontSize={16} lineHeight="23.92px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {Util.formatData(name, "")}
        </Typography>
        <Typography width="21.26%" pr="20px" color="#5DA196" fontWeight="600" fontSize={16} lineHeight="23.92px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {Util.formatData(start, "") !== "" ? Util.dateDayFormatAdmin(start) : ""}
        </Typography>
        <Typography width="21.71%" pr="20px" color="#5DA196" fontWeight="600" fontSize={16} lineHeight="23.92px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {Util.formatData(last, "") !== "" ? Util.dateDayFormatAdmin(last) : ""}
        </Typography>
      </Box>
      <Collapse in={open}>
        {Util.formatData(data, []).length > 0 ? data.map((row, index) => row?.status === "active" ? (
          <Box sx={{ display: "flex", alignItems: "center", height: "50px", }}>
            <Typography width="calc(57.03% - 45px)" height="50px" ml="45px" pl="12px" pr="20px" color="#404349" fontWeight="400" fontSize={16} lineHeight="49px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" borderBottom="1px solid #E5E5E5">
              {Util.formatData(row?.label, "")}
            </Typography>
            <Typography width="21.26%" pr="20px" height="50px" color="#404349" fontWeight="400" fontSize={16} lineHeight="49px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" borderBottom="1px solid #E5E5E5">
              {Util.formatData(row?.startDate, "") !== "" ? Util.dateDayFormatAdmin(row?.startDate) : " "}
            </Typography>
            <Typography width="21.71%" pr="20px" height="50px" color="#404349" fontWeight="400" fontSize={16} lineHeight="49px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" borderBottom="1px solid #E5E5E5">
              {Util.formatData(row?.endDate, "") !== "" ? Util.dateDayFormatAdmin(row?.endDate) : " "}
            </Typography>
          </Box>
        )
          :
          null
        )
          :
          null
        }
      </Collapse>
    </Box>
  );
};
export default Summary360;
